import { render } from "./CustomEventRender.vue?vue&type=template&id=3baa39a0&ts=true"
import script from "./CustomEventRender.vue?vue&type=script&lang=ts"
export * from "./CustomEventRender.vue?vue&type=script&lang=ts"

import "./CustomEventRender.vue?vue&type=style&index=0&id=3baa39a0&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__